import { useEffect, useState } from "react";
import { userNameRegx } from "../../../../utils/Regex/regex";
import Error from "../../../../utils/error/Error";
import { userNameErrorMessage } from "../../../../utils/errorMessages/errorMessages";
import PasswordToggle from "../../../../utils/passwordToggle/PasswordToggle";
import Select from "react-select";
import { HiCheck } from "react-icons/hi";
import { RxBox } from "react-icons/rx";
import axios from "axios";
import TeacherIdPopup from "../GsrtUserRegistration/TeacherIdPopUp";
import { getTeacherDetails } from "../GsrtUserRegistration/SoapApiGetTeacherDetail";
import { toast } from "react-toastify";
import TeacherDetailsPopup from "../GsrtUserRegistration/ViewTeacherDetailGsrt";
import { getTranslatedText } from "../../../../redux/slices/translatedText/getTranslatedText";
import { baseURL } from "../../../../utils/http/http-common";

const SetPassword = (props) => {
  const { handleChange, name, getTextTranslated, setIsButtonEnabled } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const togglePassword = (type) => {
    if (type === "password") {
      setShowPassword(!showPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const [password, setPassword] = useState("");
  const [stateBoardResponse, setStateBoardResponse] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState(null);

  // Password rules
  const rules = [
    {
      key: "length",
      label:
        getTextTranslated?.data?.length > 0
          ? getTextTranslated?.data?.filter(
              (item) => item?.pageKey === "label_password_must_8_16"
            )[0].keyValue
          : "Password must be 8-16 characters",
      test: (pw) => pw.length >= 8 && pw.length <= 16,
    },
    {
      key: "uppercase",
      label:
        getTextTranslated?.data?.length > 0
          ? getTextTranslated?.data?.filter(
              (item) => item?.pageKey === "label_include_1_uppercase"
            )[0].keyValue
          : "Including one uppercase letter",
      test: (pw) => /[A-Z]/.test(pw),
    },
    {
      key: "number",
      label:
        getTextTranslated?.data?.length > 0
          ? getTextTranslated?.data?.filter(
              (item) => item?.pageKey === "label_must_inlcude_1_number"
            )[0].keyValue
          : "Must include at least one number",
      test: (pw) => /\d/.test(pw),
    },
    {
      key: "special",
      label:
        getTextTranslated?.data?.length > 0
          ? getTextTranslated?.data?.filter(
              (item) => item?.pageKey === "label_must_inlcude_1_special_char"
            )[0].keyValue
          : "Must include at least one special character",
      test: (pw) => /[^A-Za-z0-9]/.test(pw),
    },
  ];

  const getStateBoard = () => {
    axios.get(`${baseURL}/State/GetStateBoard`).then((response) => {
      setStateBoardResponse(response?.data?.response);
    });
  };

  useEffect(() => {
    getStateBoard();
  }, []);

  const isPasswordValid = rules.every((rule) => rule.test(password.trim()));

  useEffect(() => {
    setIsButtonEnabled(false); // disable on mount
  }, []);

  const [showTeacherIdPopup, setShowTeacherIdPopup] = useState(false);
  const [teacherId, setTeacherId] = useState(null);
  const [teacherData, setTeacherData] = useState(null);
  const [showTeacherDetailPopup, setShowTeacherDetailPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableStateDropdown, setDisableStateDropdown] = useState(false);
  const [dataFoundTeacherId, setDataFoundTeacherId] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const userTypeId = localStorage.getItem("userTypeId");

  const onClickSubmit = async () => {
    setLoading(true);
    if (!teacherId || teacherId.length <= 6) {
      toast.error(
        getTranslatedText?.data?.length > 0
          ? getTranslatedText?.data?.filter(
              (item) => item?.pageKey === "teacher_id_err"
            )[0]?.keyValue
          : "Teacher id is incorrect"
      );
      setLoading(false);
      return;
    }
    const response = await getTeacherDetails("SSAIED", teacherId);
    if (response?.data?.message === "success") {
      setTeacherData(response?.data?.response); // store teacher details
      setShowTeacherIdPopup(false);
      setShowTeacherDetailPopup(true);
      setDataFoundTeacherId(true);
    } else {
      setDataFoundTeacherId(false);
      setTeacherData(null);
      toast.error(
        getTranslatedText?.data?.length > 0
          ? getTranslatedText?.data?.filter(
              (item) => item?.pageKey === "data_not_found"
            )[0]?.keyValue
          : "Data not found"
      );
    }
    setLoading(false);
    setShowTeacherIdPopup(false);
  };

  useEffect(() => {
    if (!showTeacherDetailPopup && !disableStateDropdown) {
      setDataFoundTeacherId(false);
    }
  }, [!showTeacherDetailPopup]);

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-wrap gap-4 items-start m-1">
          {/* Username field */}
          <div className="my-[0px] lg:my-[10px] text-left md:w-[45%] w-[70%] ml-5">
            <label htmlFor="userName" className="text-[15px] mb-0 text-left">
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item.pageKey === "field_username"
                  )[0].keyValue
                : "Username"}
            </label>

            <div className="relative bg-[#F6F7FA] py-2 px-3 pr-10 my-2 border border-[#F6F7FA] rounded-md">
              <input
                id="userName"
                name="userName"
                className="bg-[#F6F7FA] !outline-none"
                type="text"
                placeholder="Enter Username"
                value={name}
                minLength={3}
                maxLength={20}
                onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }}
                onChange={(e) => {
                  if (e.target.value === " ") {
                    e.preventDefault();
                  } else if (
                    !userNameRegx.test(e.target.value) ||
                    !e.target.value === " "
                  ) {
                    handleChange(e, "setPassword");
                    setShowErrorMessage(true);
                  } else {
                    setShowErrorMessage(false);
                    handleChange(e, "setPassword");
                  }
                }}
                required
                disabled={true}
              />
              {showErrorMessage && <Error message={userNameErrorMessage} />}
            </div>
          </div>

          {userTypeId === "3" ? (
            <>
              {/* Board select */}
              <div className="my-[0px] lg:my-[10px] text-left md:w-[45%] w-[70%] ml-5">
                <label
                  htmlFor="userName"
                  className="text-[15px] mb-0 text-left"
                >
                  {getTextTranslated?.data?.length > 0
                    ? getTextTranslated?.data?.filter(
                        (item) => item.pageKey === "choose_board"
                      )[0].keyValue
                    : "Choose your board"}
                  <span className="text-red-500">*</span>
                </label>
                <Select
                  className="mt-2"
                  options={stateBoardResponse.map((item) => ({
                    value: item.id, // unique key from API
                    label: item.name, // display text
                  }))}
                  onChange={(val) => {
                    setSelectedBoard(val?.value);
                    if (val?.value === 2) {
                      setShowTeacherIdPopup(true);
                    } else {
                      setDataFoundTeacherId(true);
                    }
                  }}
                  isDisabled={disableStateDropdown}
                />
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        {userTypeId === "3" ? (
          <span className="text-[12px] text-[#1B1B1B] italic text-left ml-6">
            {getTextTranslated?.data?.length > 0
              ? getTextTranslated?.data?.filter(
                  (item) => item?.pageKey === "note_message"
                )[0].keyValue
              : "Please select your State Board to enable password creation."}
          </span>
        ) : (
          ""
        )}

        <div className="flex flex-wrap gap-4 items-start m-2">
          <div className="my-[0px] lg:my-[10px] text-left md:w-[45%] w-[70%] ml-5">
            <label htmlFor="userName" className="text-[15px] mb-0 text-left">
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item?.pageKey === "key_create_password"
                  )[0].keyValue
                : "Create Password"}
            </label>
            <div className="relative bg-[#F6F7FA] py-2 px-3 pr-10 my-2 border border-[#F6F7FA] rounded-md">
              <input
                id="Password"
                name="Password"
                // className={`${
                //   selectedBoard === null ? "bg-[#E8E8E8]" : "bg-[#F6F7FA]"
                // } w-full !outline-none`}
                className="bg-[#F6F7FA] w-full !outline-none"
                type={showPassword ? "text" : "password"}
                placeholder={
                  getTextTranslated?.data?.length > 0
                    ? getTextTranslated?.data?.filter(
                        (item) => item.pageKey === "enter_password_txt"
                      )[0].keyValue
                    : "Enter Password"
                }
                minLength={8}
                maxLength={16}
                value={password}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  if (e.target.value === " ") {
                    e.preventDefault();
                  } else {
                    setPassword(e.target.value);
                    handleChange(e, "setPassword");
                  }
                }}
                //required
                disabled={
                  userTypeId === "3" &&
                  (selectedBoard === null || !dataFoundTeacherId)
                    ? true
                    : false
                }
              />

              <PasswordToggle
                showPassword={showPassword}
                setShowPassword={() => togglePassword("password")}
              />
            </div>
          </div>

          <div className="my-[0px] lg:my-[10px] text-left md:w-[45%] w-[70%] ml-5">
            <label htmlFor="userName" className="text-[15px] mb-0 text-left">
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item.pageKey === "confirm_new_password"
                  )[0].keyValue
                : "Confirm Password"}
            </label>
            <div className=" relative bg-[#F6F7FA] py-2 px-3 pr-10 my-2 border border-[#F6F7FA] rounded-md">
              <input
                id="confirmPassword"
                name="confirmPassword"
                // className={`${
                //   selectedBoard === null ? "bg-[#F6F7FA]" : "bg-[#E8E8E8]"
                // } w-full !outline-none`}
                className="bg-[#F6F7FA] w-full !outline-none"
                type={showConfirmPassword ? "text" : "password"}
                placeholder={
                  getTextTranslated?.data?.length > 0
                    ? getTextTranslated?.data?.filter(
                        (item) => item.pageKey === "confirm_pass_txt"
                      )[0].keyValue
                    : "Confirm password"
                }
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                  }
                }}
                minLength={8}
                maxLength={16}
                onChange={(e) => {
                  if (e.target.value === " ") {
                    e.preventDefault();
                  } else {
                    setConfirmPassword(e.target.value);
                    setIsButtonEnabled(
                      isPasswordValid && password === e.target.value
                    );
                    handleChange(e, "setPassword");
                  }
                }}
                //required
                disabled={
                  userTypeId === "3" &&
                  (selectedBoard === null || !dataFoundTeacherId ? true : false)
                }
              />
              <PasswordToggle
                showPassword={showConfirmPassword}
                setShowPassword={() => togglePassword("confirmPassword")}
              />
            </div>
          </div>
          {/* Rules List */}
          <ul className="ml-5 mt-0 space-y-1 text-[12px]">
            {rules.map((rule, index) => {
              const passed = rule.test(password.trim());
              return (
                <li
                  key={rule.key}
                  className="flex items-center gap-2 text-[#9F9F9F]"
                >
                  {passed ? (
                    <HiCheck size={16} className="text-green-600" />
                  ) : (
                    <RxBox size={16} className="text-gray-400" />
                  )}
                  {rule.label}
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <TeacherIdPopup
        visible={showTeacherIdPopup}
        onClose={() => setShowTeacherIdPopup(false)}
        setTeacherId={setTeacherId}
        onSubmit={onClickSubmit}
        loading={loading}
        getTranslateText={getTextTranslated}
      />
      {teacherData?.length > 0 && showTeacherDetailPopup && (
        <TeacherDetailsPopup
          visible={showTeacherDetailPopup}
          onClose={() => setShowTeacherDetailPopup(false)}
          teacher={teacherData}
          setDisableState={setDisableStateDropdown}
          getTranslateText={getTextTranslated}
        />
      )}
    </>
  );
};

export default SetPassword;
